var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-setting-join-component" }, [
    _c("div", { staticClass: "room-setting-content-box" }, [
      _c("h6", { staticClass: "room-setting-content-title" }, [
        _vm._v(_vm._s(_vm.$t("setting.join.role.title"))),
      ]),
      _c("div", { staticClass: "room-setting-content-text-box" }, [
        _c("p", { staticClass: "room-setting-content-text" }, [
          _vm._v(
            _vm._s(
              _vm.$t("setting.join.role.message", {
                0:
                  _vm.enterRole === "participant"
                    ? _vm.$t("common.participant")
                    : _vm.$t("common.emcee"),
              })
            )
          ),
        ]),
      ]),
      _c(
        "div",
        {
          staticClass: "room-setting-input-box",
          class: { disable: _vm.useWaitingRoom },
        },
        _vm._l(_vm.roleList, function (role, i) {
          return _c("label", { key: i, staticClass: "room-setting-label" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.enterRole,
                  expression: "enterRole",
                },
              ],
              staticClass: "room-setting-radio",
              attrs: { type: "radio", name: "setEntryAuth" },
              domProps: {
                value: role.value,
                checked: _vm._q(_vm.enterRole, role.value),
              },
              on: {
                change: function ($event) {
                  _vm.enterRole = role.value
                },
              },
            }),
            _c("span", [_vm._v(_vm._s(role.title))]),
          ])
        }),
        0
      ),
      _vm.useWaitingRoom
        ? _c("div", { staticClass: "room-setting-content-text-box" }, [
            _c(
              "p",
              { staticClass: "room-setting-content-text use-waiting-room" },
              [_vm._v(_vm._s(_vm.$t("setting.waitingRoom.text")))]
            ),
          ])
        : _vm._e(),
    ]),
    _c("div", { staticClass: "room-setting-content-box" }, [
      _c("h6", { staticClass: "room-setting-content-title" }, [
        _vm._v(_vm._s(_vm.$t("setting.join.device.title"))),
      ]),
      _c("div", { staticClass: "room-setting-content-text-box" }, [
        _c("p", { staticClass: "room-setting-content-text" }, [
          _vm._v(_vm._s(_vm.$t("setting.join.device.text"))),
        ]),
      ]),
      _c("div", { staticClass: "room-setting-input-box" }, [
        _c(
          "div",
          { staticClass: "room-set-block-btn-box device-join-select" },
          [
            _c(
              "ul",
              _vm._l(_vm.deviceList, function (device, i) {
                return _c(
                  "li",
                  {
                    key: i,
                    class: {
                      selected: _vm.params.defaultDeviceType == device.value,
                    },
                    attrs: { name: device.value },
                    on: {
                      click: function ($event) {
                        return _vm.CHANGE_SETTING_DATA({
                          type: "defaultDeviceType",
                          value: device.value,
                        })
                      },
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "room-set-block-btn",
                        attrs: { tabindex: "1" },
                      },
                      [_vm._v(_vm._s(device.title))]
                    ),
                  ]
                )
              }),
              0
            ),
          ]
        ),
      ]),
    ]),
    _c("div", { staticClass: "room-setting-content-box" }, [
      _c("h6", { staticClass: "room-setting-content-title" }, [
        _vm._v(_vm._s(_vm.$t("setting.join.default.title"))),
      ]),
      _c("div", { staticClass: "room-setting-content-text-box" }, [
        _c("p", { staticClass: "room-setting-content-text" }, [
          _vm._v(_vm._s(_vm.$t("setting.join.default.text"))),
        ]),
      ]),
      _c("div", { staticClass: "room-setting-input-box" }, [
        _c("label", { staticClass: "room-setting-label" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.isCameraOn,
                expression: "isCameraOn",
              },
            ],
            staticClass: "room-setting-radio",
            attrs: { type: "checkbox", name: "defaultRoleCamera" },
            domProps: {
              checked: Array.isArray(_vm.isCameraOn)
                ? _vm._i(_vm.isCameraOn, null) > -1
                : _vm.isCameraOn,
            },
            on: {
              click: function ($event) {
                return _vm.CHANGE_SETTING_DATA({
                  type: "defaultRoleCamera",
                  value: !_vm.isCameraOn,
                })
              },
              change: function ($event) {
                var $$a = _vm.isCameraOn,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.isCameraOn = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.isCameraOn = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.isCameraOn = $$c
                }
              },
            },
          }),
          _c("span", [_vm._v(_vm._s(_vm.$t("common.device.camera")))]),
        ]),
        _c("label", { staticClass: "room-setting-label" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.isMicOn,
                expression: "isMicOn",
              },
            ],
            staticClass: "room-setting-radio",
            attrs: { type: "checkbox", name: "defaultRoleMic" },
            domProps: {
              checked: Array.isArray(_vm.isMicOn)
                ? _vm._i(_vm.isMicOn, null) > -1
                : _vm.isMicOn,
            },
            on: {
              click: function ($event) {
                return _vm.CHANGE_SETTING_DATA({
                  type: "defaultRoleMic",
                  value: !_vm.isMicOn,
                })
              },
              change: function ($event) {
                var $$a = _vm.isMicOn,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.isMicOn = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.isMicOn = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.isMicOn = $$c
                }
              },
            },
          }),
          _c("span", [_vm._v(_vm._s(_vm.$t("common.device.mic")))]),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "room-setting-content-box" }, [
      _c("h6", { staticClass: "room-setting-content-title" }, [
        _vm._v(_vm._s(_vm.$t("setting.join.rejoin.title"))),
      ]),
      _c("div", { staticClass: "room-setting-content-text-box" }, [
        _c("p", { staticClass: "room-setting-content-text" }, [
          _vm._v(_vm._s(_vm.$t("setting.join.rejoin.text"))),
        ]),
      ]),
      _c("div", { staticClass: "room-setting-input-box" }, [
        _c("label", { staticClass: "room-setting-label" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.isResetRole,
                expression: "isResetRole",
              },
            ],
            staticClass: "room-setting-radio",
            attrs: { type: "checkbox", name: "defaultRoleReset" },
            domProps: {
              checked: Array.isArray(_vm.isResetRole)
                ? _vm._i(_vm.isResetRole, null) > -1
                : _vm.isResetRole,
            },
            on: {
              click: function ($event) {
                return _vm.CHANGE_SETTING_DATA({
                  type: "defaultRoleReset",
                  value: !_vm.isResetRole,
                })
              },
              change: function ($event) {
                var $$a = _vm.isResetRole,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.isResetRole = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.isResetRole = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.isResetRole = $$c
                }
              },
            },
          }),
          _c("span", [_vm._v(_vm._s(_vm.$t("setting.join.rejoin.init")))]),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "room-setting-content-box" }, [
      _c("h6", { staticClass: "room-setting-content-title" }, [
        _vm._v(_vm._s(_vm.$t("setting.waitingRoom.title"))),
      ]),
      _c("div", { staticClass: "room-setting-content-text-box" }, [
        _c("p", { staticClass: "room-setting-content-text" }, [
          _vm._v(_vm._s(_vm.$t("setting.waitingRoom.text"))),
        ]),
      ]),
      _c("div", { staticClass: "room-setting-input-box" }, [
        _c("label", { staticClass: "room-setting-label" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.useWaitingRoom,
                expression: "useWaitingRoom",
              },
            ],
            staticClass: "room-setting-radio useEntryWaitingRoom",
            attrs: { type: "checkbox", name: "entryWaitingRoom" },
            domProps: {
              checked: Array.isArray(_vm.useWaitingRoom)
                ? _vm._i(_vm.useWaitingRoom, null) > -1
                : _vm.useWaitingRoom,
            },
            on: {
              click: function ($event) {
                return _vm.CHANGE_SETTING_DATA({
                  type: "useWaitingMode",
                  value: !_vm.useWaitingRoom,
                })
              },
              change: function ($event) {
                var $$a = _vm.useWaitingRoom,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.useWaitingRoom = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.useWaitingRoom = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.useWaitingRoom = $$c
                }
              },
            },
          }),
          _c("span", [_vm._v(_vm._s(_vm.$t("setting.waitingRoom.use")))]),
        ]),
      ]),
      _c(
        "div",
        {
          staticClass: "room-setting-input-box sub",
          class: { disable: !_vm.useWaitingRoom },
        },
        [
          _c("label", { staticClass: "room-setting-label" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.isDeviceRequired,
                  expression: "isDeviceRequired",
                },
              ],
              staticClass: "room-setting-radio useEntryWaitingRoom",
              attrs: { type: "checkbox", name: "entryWaitingRoom" },
              domProps: {
                checked: Array.isArray(_vm.isDeviceRequired)
                  ? _vm._i(_vm.isDeviceRequired, null) > -1
                  : _vm.isDeviceRequired,
              },
              on: {
                click: function ($event) {
                  return _vm.CHANGE_SETTING_DATA({
                    type: "isDeviceRequired",
                    value: !_vm.isDeviceRequired,
                  })
                },
                change: function ($event) {
                  var $$a = _vm.isDeviceRequired,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.isDeviceRequired = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.isDeviceRequired = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.isDeviceRequired = $$c
                  }
                },
              },
            }),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("setting.waitingRoom.essential"))),
            ]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }